// Overlay a proposal's custom (agent-branded) examples onto the public default video slots.
// Several custom videos can share one slot (e.g. three NarraTour demos) → alternates.
export const applyCustomExamples = (data, proposal) => {
  if (!proposal?.use_custom_examples || !(proposal.custom_examples || []).length) return data;
  const byId = {};
  proposal.custom_examples.forEach((o) => { (byId[o.override_id] = byId[o.override_id] || []).push(o); });
  const applyOv = (v) => {
    const list = byId[v.id];
    if (!list || !list.length) return v;
    const first = list[0];
    return {
      ...v, url: first.url, label: first.label || v.label, poster_url: first.poster_url || '', is_custom: true,
      alternates: list.map((o) => ({ url: o.url, poster_url: o.poster_url || '', label: o.label || v.label, is_custom: true })),
    };
  };
  return {
    introductions: (data.introductions || []).map(applyOv),
    examples: (data.examples || []).map(applyOv),
  };
};

export const EMPTY_VIDEOS = { introductions: [], examples: [] };
